import type {ChildDefs} from './types';

export const PARENT_TO_CHILD_TYPE =
  'stripe-third-party-parent-to-child' as const;
export const CHILD_TO_PARENT_TYPE =
  'stripe-third-party-child-to-parent' as const;
export const READY_TYPE = 'stripe-third-party-frame-ready' as const;
export const ERROR_TYPE = 'stripe-third-party-frame-error' as const;
export const CHILD_DEFINITIONS: ChildDefs = {
  ShopPayButton: {path: 'ShopPayButton.html'},
  DemoPayButton: {path: 'DemoPayButton.html'},
  Arkose: {path: 'Arkose.html'},
  ArkoseActive: {path: 'ArkoseActive.html'},
  AddressAutocomplete: {path: 'AddressAutocomplete.html'},
  AffirmInContext: {path: 'AffirmInContext.html'},
  AfterpayInContext: {path: 'AfterpayInContext.html'},
  AmazonPayButton: {path: 'AmazonPayButton.html'},
  ApplePay: {path: 'ApplePay.html'},
  IssuingAddToAppleWalletButton: {path: 'IssuingAddToAppleWalletButton.html'},
  AuthMap: {path: 'AuthMap.html'},
  DynamicMap: {path: 'DynamicMap.html'},
  GlanceAgentSdk: {path: 'GlanceAgentSdk.html'},
  GoogleAnalytics: {path: 'GoogleAnalytics.html'},
  GoogleTagManager: {path: 'GoogleTagManager.html'},
  GoogleMaps: {path: 'GoogleMaps.html'},
  GoogleAPI: {path: 'GoogleAPI.html'},
  GooglePay: {path: 'GooglePay.html'},
  GoogleUserContent: {path: 'GoogleUserContent.html'},
  HCaptcha: {path: 'HCaptcha.html'},
  HCaptchaInvisible: {path: 'HCaptchaInvisible.html'},
  HumanSecurity: {path: 'HumanSecurity.html'},
  HumanSecurityActive: {path: 'HumanSecurityActive.html'},
  HomeFeedItemPreview: {path: 'HomeFeedItemPreview.html'},
  Iovation: {path: 'iovation.html'},
  KlarnaExpressButton: {path: 'KlarnaExpressButton.html'},
  KlarnaInContext: {path: 'KlarnaInContext.html'},
  KnakEmailPreview: {path: 'KnakEmailPreview.html'},
  LeanDataBookit: {path: 'LeanDataBookit.html'},
  LeanDataCustomCalendarBooking: {path: 'LeanDataCustomCalendarBooking.html'},
  RLogger: {path: 'RLogger.html'},
  Sprig: {path: 'Sprig.html'},
  SprigV2: {path: 'SprigV2.html'},
  StaticMap: {path: 'StaticMap.html'},
  StatusSite: {path: 'StatusSite.html'},
  StripeJsV3: {path: 'StripeJsV3.html'},
  TelnyxVoice: {path: 'TelnyxVoice.html'},
  Twilio: {path: 'Twilio.html'},
  TwilioConversations: {path: 'TwilioConversations.html'},
  TwilioVoice: {path: 'TwilioVoice.html'},
  TwitterEmbed: {path: 'TwitterEmbed.html'},
  YouTubePlayer: {path: 'YouTubePlayer.html'},
  PaypalECS: {path: 'PaypalECS.html'},
  PaypalFraudnet: {path: 'PaypalFraudnet.html'},
  PrivacyCompliance: {path: 'PrivacyCompliance.html'},
  LedgerWallet: {path: 'LedgerWallet.html'},
  MillicastViewer: {path: 'MillicastViewer.html'},
  Perfetto: {path: 'Perfetto.html'},
  RechnungDeviceFingerprint: {path: 'RechnungDeviceFingerprint.html'},
  Wordly: {path: 'Wordly.html'},
};
